import {ModuleWithProviders, NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {SigninComponent} from "@app/pages/signin/signin.component";
import {NewsComponent} from "@app/pages/news/news.component";
import {AdminComponent} from "@app/pages/admin/admin.component";
import {RouteGuardService} from "@app/services/route-guard/route-guard.service";
import {TicketsComponent} from "@app/pages/tickets/tickets.component";
import {NewTicketComponent} from "@app/pages/tickets/new-ticket/new-ticket.component";
import {DocumentsComponent} from "@app/pages/documents/documents.component";
import {DeploymentsComponent} from "@app/pages/deployments/deployments.component";
import {AdminRouteGuardService} from "@app/services/route-guard/admin-route-guard.service";
import {LogsComponent} from "@app/pages/logs/logs.component";
import {DashboardComponent} from "@app/pages/dashboard/dashboard.component";
import {HraComponent} from "@app/pages/tickets/hra/hra.component";
import {UserComponent} from "@app/pages/user/user.component";
import {TicketViewComponent} from "@app/pages/tickets/ticket-view/ticket-view.component";

export const appRoutes: Routes = [
    {
        path: 'tickets',
        canActivate: [RouteGuardService],
        component: TicketsComponent,
    },
    {
        path: 'admin',
        canActivate: [RouteGuardService, AdminRouteGuardService],
        component: AdminComponent,
    },
    {
        path: 'news',
        canActivate: [RouteGuardService],
        component: NewsComponent,
    },
    {
        path: 'signin',
        component: SigninComponent,
    },
    {
        path: 'new-ticket',
        canActivate: [RouteGuardService],
        component: NewTicketComponent,
    },
    {
        path: 'ticket/view',
        canActivate: [RouteGuardService],
        component: TicketViewComponent,
    },
    {
      path: 'edit',
      canActivate: [RouteGuardService],
      component: NewTicketComponent,
    },
    {
        path: 'documents',
        canActivate: [RouteGuardService],
        component: DocumentsComponent
    },
    {
        path: 'deployments',
        canActivate: [RouteGuardService],
        component: DeploymentsComponent
    },
    {
        path: 'high-risk-security',
        canActivate: [RouteGuardService],
        component: HraComponent
    },
    {
        path: 'logs',
        canActivate: [RouteGuardService],
        component: LogsComponent
    },
    {
      path:'dashboard',
      canActivate:[RouteGuardService, AdminRouteGuardService],
      component: DashboardComponent
    },
    {
        path: 'user',
        canActivate: [RouteGuardService],
        component: UserComponent
    },
    {
        path: '',
        pathMatch: 'prefix',
        redirectTo: 'signin',
    },
    {
        path: '**',
        pathMatch: 'prefix',
        redirectTo: 'signin',
    },
];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes, {useHash: true});

@NgModule({
    imports: [routing],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
